export default function Loader() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <img src="/assets/loading.gif" className=" w-14 h-14" />
    </div>
  );
}
